<script setup>
  import {onMounted, onUnmounted, provide, ref} from "vue";

  import {cn} from "@pharma4u/medicheck-components/utils";

  defineOptions({
    name: "AuthHeaderDropdown",
  });

  defineProps({
    alignment: {
      type: String,
      default: "left",
      validator: (value) => ["left", "right"].includes(value),
    },
    label: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    href: {
      type: String,
      default: null,
    },
  });

  const isOpen = ref(false);
  const dropdown = ref(null);

  onMounted(() => {
    globalThis.addEventListener("click", closeDropdownOnOutsideClick);
  });

  onUnmounted(() => {
    globalThis.removeEventListener("click", closeDropdownOnOutsideClick);
  });

  const toggleDropdown = () => {
    isOpen.value = !isOpen.value;
  };

  const closeDropdownOnOutsideClick = (event) => {
    if (isOpen.value && dropdown.value && !dropdown.value.contains(event.target)) isOpen.value = false;
  };

  provide("authDropdownContext", {
    isOpen,
  });
</script>

<template>
  <div ref="dropdown" class="relative" :data-test="getTestId('dropdown')">
    <div
      :class="cn('headline-container cursor-pointer', {'text-gray-900': isOpen})"
      role="button"
      tabindex="0"
      :data-test="getTestId('dÌropdown-trigger')"
      @click="toggleDropdown"
      @keydown.enter="toggleDropdown"
      @keydown.space.prevent="toggleDropdown"
    >
      <slot name="headline" />
    </div>

    <!-- Click handler closes dropdown when clicking outside options (UX pattern) -->
    <!-- eslint-disable-next-line vuejs-accessibility/no-static-element-interactions, vuejs-accessibility/click-events-have-key-events -->
    <div
      v-if="isOpen"
      :class="
        cn(
          'absolute mt-2 w-screen max-w-xs flex-col space-y-2 rounded-md border border-gray-300 bg-white p-4 shadow-lg focus:outline-none',
          {
            'right-0': alignment === 'right',
            'left-0': alignment === 'left',
          },
        )
      "
      :data-test="getTestId('dropdown-options')"
      @click="toggleDropdown"
    >
      <slot name="options" />
    </div>
  </div>
</template>
